import React from 'react';
import SidebarNavLinks from '../Sidebar/SidebarNavLinks';

interface MobileBurgerSideBarProps {
  isVisible: boolean;
  onClose: () => void;
}

const MobileBurgerSideBar = ({ isVisible, onClose }: MobileBurgerSideBarProps) => (
  <>
    {isVisible && (
      <button type="button" className="mobile-burger-sidebar-backdrop" onClick={onClose} aria-label="Close menu" />
    )}
    <div className={`mobile-burger-sidebar ${isVisible ? 'visible' : ''}`}>
      <SidebarNavLinks onNavigate={onClose} />
    </div>
  </>
);

export default MobileBurgerSideBar;
